// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sGZgCAN5pNpFD6 {
  padding: 10px 25px;
  vertical-align: middle;
}
.mxYEGZvUAZPGtv,
.GgWOecmuOHk4to {
  display: inline;
  margin-right: 5px;
  margin-left: 10px;
  font-size: bold;
  vertical-align: text-bottom;
}
.GgWOecmuOHk4to {
  border-bottom: 1px dashed var(--ds-text-subtlest, #626f86);
  cursor: pointer;
}
._HnF4jhJlfzEfm td:nth-child(4) {
  border-right: 4px solid var(--ds-border-discovery, #8270db);
  border-left: 3px solid var(--ds-border-discovery, #8270db);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"featureContent": `sGZgCAN5pNpFD6`,
	"featureNameNoTooltip": `mxYEGZvUAZPGtv`,
	"featureName": `GgWOecmuOHk4to`,
	"row": `_HnF4jhJlfzEfm`
};
export default ___CSS_LOADER_EXPORT___;
